import { render, staticRenderFns } from "./Basic.vue?vue&type=template&id=6ccf0eb2"
import script from "./Basic.vue?vue&type=script&lang=js"
export * from "./Basic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports